var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C18 23.5913 18.6321 25.1174 19.7574 26.2426C20.8826 27.3679 22.4087 28 24 28C25.5913 28 27.1174 27.3679 28.2426 26.2426C29.3679 25.1174 30 23.5913 30 22C30 20.4087 29.3679 18.8826 28.2426 17.7574C27.1174 16.6321 25.5913 16 24 16C22.4087 16 20.8826 16.6321 19.7574 17.7574C18.6321 18.8826 18 20.4087 18 22Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.314 33.3144L26.828 41.8004C26.078 42.5497 25.0612 42.9705 24.001 42.9705C22.9408 42.9705 21.924 42.5497 21.174 41.8004L12.686 33.3144C10.4484 31.0767 8.92468 28.2258 8.30738 25.1221C7.69009 22.0184 8.00699 18.8014 9.21801 15.8779C10.429 12.9543 12.4798 10.4555 15.111 8.69741C17.7421 6.93934 20.8355 6.00098 24 6.00098C27.1645 6.00098 30.2579 6.93934 32.889 8.69741C35.5202 10.4555 37.571 12.9543 38.782 15.8779C39.993 18.8014 40.3099 22.0184 39.6926 25.1221C39.0753 28.2258 37.5516 31.0767 35.314 33.3144Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.22da21d90bf991cc1692f91f854c0184.svg";
export { ForwardRef as ReactComponent };